export default __webpack_public_path__ + "static/media/rshiner-blog.461acd69.png";